<div class="container d-flex align-items-center h-100 justify-content-center">
    <div class="error-page">
      <p>
        <img src="assets/images/maintenance.svg#maintenance" alt="Maintenance" class="img-fluid" />
      </p>
    
      <div class="col-12 error-msg">
        <h1>The site is going under maintenance!</h1>
        <p>We are updating our system and working hard to come back online with updated features.</p>
        <h2>Come back later!</h2>
      </div>
    </div>
  </div>
  